import { Controller } from "@hotwired/stimulus"

// Controlador para alternar visibilidad de contraseña
export default class extends Controller {
  static targets = ["input", "eyeOpen", "eyeClosed"]

  connect() {
    // Estado inicial: contraseña oculta, mostrar ojo abierto
    this.eyeOpenTarget.classList.remove("hidden")
    this.eyeClosedTarget.classList.add("hidden")
  }

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      this.eyeOpenTarget.classList.add("hidden")
      this.eyeClosedTarget.classList.remove("hidden")
    } else {
      this.inputTarget.type = "password"
      this.eyeOpenTarget.classList.remove("hidden")
      this.eyeClosedTarget.classList.add("hidden")
    }
  }
}
